// src/components/modal/ModalTitle.tsx

import React, { ReactNode } from 'react';

interface ModalTitleProps {
  children?: ReactNode;
  className?: string;
}

function ModalTitle({
  children,
  className = '',
}: ModalTitleProps) {
  return (
    <h2 className={`text-xl font-semibold ${className}`}>
      {children}
    </h2>
  );
}

export default ModalTitle;